import { useTonConnectUI } from "@tonconnect/ui-react"
import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { formatWalletAddress } from "@/helpers/formatWalletAddress"
import { useModals } from "@/modals"
import { useGetUserDataQuery } from "@/store/apis/userAPI"
import styles from "./ConnectWalletChip.module.scss"
import type { IConnectWalletChip } from "./types"

export const ConnectWalletChip: FC<IConnectWalletChip> = ({
  className,
  ...rest
}) => {
  const { t } = useTranslation()
  const [tonConnectUI] = useTonConnectUI()
  const { openModal } = useModals()
  const { walletAddress } = useGetUserDataQuery(undefined, {
    selectFromResult: ({ data }) => ({
      walletAddress: data?.wallets?.telegram
    })
  })

  const shortAddress = walletAddress ? formatWalletAddress(walletAddress) : null

  const handleClick = () => {
    if (walletAddress) {
      openModal("disconnectWallet")
    } else {
      tonConnectUI.openModal()
    }
  }

  return (
    <button
      type="button"
      aria-label={
        walletAddress
          ? t("wallet.withdraw.chip.disconnect")
          : t("wallet.withdraw.chip.connect")
      }
      {...rest}
      className={clsx(
        styles.ConnectWalletChip,
        { [styles.connected]: !!walletAddress },
        className
      )}
      onClick={handleClick}
    >
      <span className={styles.ConnectWalletChip_top}>
        {shortAddress ?? t("wallet.withdraw.chip.connect")}
      </span>
    </button>
  )
}
